import { call, put } from "redux-saga/effects";
import * as types from "../const";
import { postAddTenantUser } from "../api";

export function* postAddTenantUserRequestSaga({
  payload,
}: ReturnType<typeof Object>) {
  try {
    const addTenantUser: object = yield call(postAddTenantUser, payload);
    yield put({ type: types.POST_ADD_USER_SUCCESS, addTenantUser });
  } catch (error) {
    yield put({ type: types.POST_ADD_USER_ERROR, error });
  }
}
